import classNames from "classnames";

export function getDashboardStackGapClassName(isSingleColumnLayout: boolean) {
  return isSingleColumnLayout ? "gap-8" : "gap-6";
}

export function getDashboardColumnsLayoutClassName(isSingleColumnLayout: boolean, belowTabs = false) {
  const topSpacing = belowTabs ? "mt-12" : "mt-6";
  return isSingleColumnLayout ? `${topSpacing} flex flex-col gap-8` : `${topSpacing} flex flex-row items-start gap-6`;
}

export function getDashboardPrimaryColumnClassName(isSingleColumnLayout: boolean) {
  return classNames("flex min-w-0 flex-1 flex-col", getDashboardStackGapClassName(isSingleColumnLayout));
}

export function getDashboardSidebarColumnClassName(isSingleColumnLayout: boolean, hasPrimaryColumn: boolean) {
  return classNames(
    "flex w-full flex-col",
    getDashboardStackGapClassName(isSingleColumnLayout),
    hasPrimaryColumn && !isSingleColumnLayout ? "shrink-0 max-w-sm" : ""
  );
}

export function getDashboardPanelStackClassName(isSingleColumnLayout: boolean) {
  return classNames("flex flex-col", getDashboardStackGapClassName(isSingleColumnLayout));
}
